<template>
  <div v-loading="isLoading">
    <el-table
      :data="dgItems"
      stripe
    >
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-row :gutter="10">
            <el-col :md="6">
              <p><strong>Product Class: </strong>{{ props.row.itemdg_prodclass || '-' }}</p>
              <p><strong>Proper Name: </strong>{{ props.row.itemdg_propname || '-' }}</p>
              <p><strong>Common Name: </strong>{{ props.row.itemdg_comname || '-' }}</p>
            </el-col>
            <el-col :md="6">
              <p><strong>Class: </strong>{{ props.row.itemdg_hazclass || '-' }}</p>
              <p><strong>UN Number: </strong>{{ props.row.itemdg_unno || '-' }}</p>
              <p><strong>Hazchem Code: </strong>{{ props.row.itemdg_hazcode || '-' }}</p>
              <p><strong>Sub Risk: </strong>{{ props.row.itemdg_subrisk || '-' }}</p>
            </el-col>
            <el-col :md="6">
              <p><strong>Packing Group: </strong>{{ props.row.itemdg_packgroup || '-' }}</p>
              <p><strong>Packing Type: </strong>{{ props.row.itemdg_packtype || '-' }}</p>
              <p><strong>Marine Pollutant: </strong>{{ props.row.itemdg_marpol ? 'Yes' : 'No' || '-' }}</p>
            </el-col>
            <el-col :md="6">
              <p><strong>Flash Point: </strong>{{ props.row.itemdg_flashpt || '-' }}</p>
              <p><strong>Additional Information: </strong>{{ props.row.itemdg_addinfo || '-' }}</p>
              <p><strong>API Code: </strong>{{ props.row.itemdg_apicode || '-' }}</p>
            </el-col>
          </el-row>
        </template>
      </el-table-column>

      <el-table-column
        label="Proper Name"
        prop="itemdg_propname"
        min-width="250px"
        show-overflow-tooltip
        :formatter="(row, col, cellValue) => cellValue || '-'"
      />

      <el-table-column
        label="Common Name"
        prop="itemdg_comname"
        min-width="250px"
        show-overflow-tooltip
        :formatter="(row, col, cellValue) => cellValue || '-'"
      />

      <el-table-column
        label="Class"
        prop="itemdg_hazclass"
        width="120px"
        show-overflow-tooltip
        :formatter="(row, col, cellValue) => cellValue || '-'"
      />

      <el-table-column
        label="UN Number"
        prop="itemdg_unno"
        width="120px"
        show-overflow-tooltip
        :formatter="(row, col, cellValue) => cellValue || '-'"
      />

      <el-table-column
        label="Hazchem"
        prop="itemdg_hazcode"
        width="120px"
        show-overflow-tooltip
        :formatter="(row, col, cellValue) => cellValue || '-'"
      />

      <el-table-column
        label="Marine Pollutant"
        prop="itemdg_marpol"
        width="150px"
        show-overflow-tooltip
        :formatter="(row, col, cellValue) => cellValue == 1 ? 'Yes' : 'No' || '-'"
      />

      <el-table-column
        v-if="canUpdate || canDelete"
        label="Actions"
        align="right"
        width="200px"
      >
        <template slot-scope="scope">
          <el-button
            v-if="canUpdate"
            size="mini"
            @click.native="editdgItem(scope.$index, scope.row)"
          >
            Edit
          </el-button>
          <el-button
            v-if="canDelete"
            size="mini"
            type="danger"
            @click.native="deletedgItem(scope.$index, scope.row)"
          >
            Delete
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- Pagination -->
    <br>
    <div style="text-align: center;">
      <el-pagination
        :current-page.sync="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size.sync="perPage"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="loadTable()"
        @current-change="loadTable()"
      />
    </div>
    <!-- Edit Form -->
    <ItemDGEditForm
      v-if="isShowEditForm"
      ref="editForm"
      :is-show.sync="isShowEditForm"
      :dg-item="dgItem"
      :account-id="accountId"
      @saved="loadTable"
    />
  </div>
</template>

<script>
import ItemDGEditForm from '@/components/Application/Manage/Account/ItemDGEditForm'
// import { CREATE, UPDATE, DELETE } from '@/plugins/user'

export default {
  components: {
    ItemDGEditForm
  },
  props: {
    filters: {
      type: Array,
      required: true
    },
    accountId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      dgItem: null,
      dgItems: [],
      page: 1,
      perPage: 10,
      total: 0,
      isLoading: true,
      isShowEditForm: false
    }
  },
  computed: {
    canUpdate () {
      return true
    },
    canDelete () {
      return true
    }
  },
  mounted () {
    this.actions = [
      [
        {
          name: 'Import',
          icon: ['fal', 'upload'],
          event: () => {
            this.$emit('update:isShowImport', true)
          }
        },
        {
          name: 'Export',
          icon: ['fal', 'download'],
          event: () => {
            this.$emit('update:isShow', true)
          }
        }
      ],
      [
        {
          hidden: false,
          name: 'Create',
          icon: ['fal', 'plus'],
          event: () => {
            this.dgItem = new this.$sdk.account_itemsdg()
            this.isShowEditForm = true
          }
        },
        {
          name: 'Refresh',
          icon: ['fal', 'sync'],
          event: () => this.loadTable()
        }
      ]
    ]
  },
  methods: {
    loadTable () {
      this.isLoading = true
      this.$sdk.account_itemsdg.list(builder => {
        builder.context = { resource: 'account', id: this.accountId }
        builder.page = this.page
        builder.limit = this.perPage
        builder.order = 'uuid:asc'
        builder.filters = this.filters
      })
        .then(res => {
          this.dgItems = res
          this.total = res.total
        })
        .finally(() => { this.isLoading = false })
    },
    editdgItem (index, row) {
      this.dgItem = row.clone()
      this.isShowEditForm = true
    },
    deletedgItem (index, row) {
      this.$confirm('Are you sure to delete this DG entry?', 'Delete', {
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.isLoading = true
        row.delete(builder => {
          builder.context = { resource: 'account', id: this.accountId }
        })
          .then(() => this.$message({ message: 'Successfully deleted', type: 'success' }))
          .finally(() => this.loadTable())
      }).catch(() => {})
    }
  }
}
</script>

<style>

</style>
